export default __webpack_public_path__ + "static/media/walletconnect.4ac05bd8.svg";